/* filters the object and checks if it is empty */
angular.module('westBerkshireEvents.isEmptyFilter').filter('wbIsEmptyFilter', function() {
    var prop;
    return function (dynamicFilters) {
        if (dynamicFilters && dynamicFilters.values) {
            for (prop in dynamicFilters.values) {
                if (dynamicFilters.values[prop]) {
                    return true;
                }
            }
        }
        return false;
    };
});


// WEBPACK FOOTER //
// src/public/javascripts/is-empty-filter/is_empty.filter.js